import { render } from "./TheLanguageSelector.vue?vue&type=template&id=5a38e335&scoped=true"
import script from "./TheLanguageSelector.vue?vue&type=script&lang=js"
export * from "./TheLanguageSelector.vue?vue&type=script&lang=js"

import "./TheLanguageSelector.css?vue&type=style&index=0&id=5a38e335&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a38e335"]])

export default __exports__